import { getTreatment } from '../../helpers/featureFlags';
import { sendTagManagerEvent } from '../../helpers/sendTagManagerEvent';
import type { Thunk } from '../../interfaces/State';
import * as selectors from '../selectors';

export const SHOW_DAILY_STREAK_SCREEN = 'streaks/SHOW_DAILY_STREAK_SCREEN';
export type ShowDailyStreakScreenAction = {
  type: typeof SHOW_DAILY_STREAK_SCREEN;
};
export const showDailyStreakScreen = (): ShowDailyStreakScreenAction => ({
  type: SHOW_DAILY_STREAK_SCREEN,
});

export const HIDE_DAILY_STREAK_SCREEN = 'streaks/HIDE_DAILY_STREAK_SCREEN';
export type HideDailyStreakScreenAction = {
  type: typeof HIDE_DAILY_STREAK_SCREEN;
};
export const hideDailyStreakScreen = (): HideDailyStreakScreenAction => ({
  type: HIDE_DAILY_STREAK_SCREEN,
});

export const checkDailyStreak = (): Thunk => (dispatch, getState) => {
  const state = getState();

  const hasSeenCampusTour = selectors.selectHasSeenCampusTour(state);
  const streakInfoReady = selectors.selectStreakInfoReady(state);
  const streakDailyGoalMetInSession = selectors.selectStreakDailyGoalMetInSession(
    state,
  );

  if (!streakInfoReady || !streakDailyGoalMetInSession || !hasSeenCampusTour) {
    return;
  }

  const treatment = getTreatment('wl--streaks-communication');

  if (treatment && treatment !== 'control') {
    sendTagManagerEvent({
      bucket: treatment,
      event: 'bucket_experiment',
      experimentName: 'wl--streaks-communication',
    });
  }

  if (treatment === 'on') {
    dispatch(showDailyStreakScreen());
  }
};

export type StreakActions =
  | HideDailyStreakScreenAction
  | ShowDailyStreakScreenAction;
